export const StatusTrackerKeys = {
    tinyUrl: '_tinyUrl',
    autoCarPlate: '_autoCarPlate',
}